document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".footer-title").forEach(function (title) {
    title.addEventListener("click", function () {
      const section = this.parentElement.parentElement;
      section.classList.toggle("hh-active");
    });
  });

  document.body.addEventListener("click", function (event) {
    if (
      event.target.matches(".iwish-backdrop") ||
      event.target.matches(".iwish_drawer_close")
    ) {
      setTimeout(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {},
          })
        );
      }, 1000);
    }
  });
});

// LOAD MORE FEATURE
function loadMoreProducts() {
  const productsOnPage = document.querySelector(".product-list");
  let nextUrl = productsOnPage?.dataset.nextUrl;

  const loadMoreBtn = document.querySelector(".load-more_btn");
  const loadMoreSpinner = document.querySelector(".load-more_spinner");
  if (!nextUrl) return;

  loadMoreBtn.style.display = "none";
  loadMoreSpinner.style.display = "block";

  fetch(nextUrl)
    .then((response) => response.text())
    .then((html) => {
      loadMoreSpinner.style.display = "none";

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const newProducts = tempDiv.querySelector(".product-list");
      const newUrl = newProducts?.dataset.nextUrl;

      if (newUrl) loadMoreBtn.style.display = "block";

      nextUrl = newUrl;
      productsOnPage.insertAdjacentHTML("beforeend", newProducts.innerHTML);
      const insertedCards = productsOnPage.querySelectorAll(".product-card");
      insertedCards.forEach((card) => {
        card.style.opacity = "1";
        card.style.transform = "translateY(0px)";
      });

      const descEl = document.querySelector(".hh-collection-desc");
      if (descEl) {
        descEl.style.display = "none";
      }
      productsOnPage.setAttribute("data-next-url", nextUrl);
    });
}

document.addEventListener("click", function (e) {
  if (e.target.closest(".load-more_btn")) {
    e.preventDefault();
    loadMoreProducts();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("#shopify-section-sections--25558505718025__header");
  if (header && !header.hasAttribute("aria-label")) {
    // header.setAttribute("role", "banner");
    header.setAttribute("aria-label", "Main Site Header");
  }
  
  const footer = document.querySelector(".shopify-section--footer");
  if (footer && !footer.hasAttribute("role")) {
    footer.setAttribute("role", "contentinfo");
  }
  const announcementBar = document.querySelector(".shopify-section--announcement-bar");
  if (announcementBar && !announcementBar.hasAttribute("role")) {
    announcementBar.setAttribute("aria-label", "Announcement Bar");
  }

});
// Hover Cart Drawer
// document.addEventListener("DOMContentLoaded", function () {
//   const cartLink = document.querySelector(".header__cart-link a");
//   const cartDrawer = document.querySelector("cart-drawer");

//   if (cartLink) {
//     cartLink.addEventListener("mouseenter", function () {
//       cartLink.setAttribute("aria-expanded", "true");
//       cartDrawer.show();
//     });
//   }
// });

document.addEventListener("click", function (event) {
  // Check if the clicked element matches .collection-toolbar__button
  if (event.target.closest('.collection-toolbar__button')) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("filter.v.availability") && urlParams.get("filter.v.availability") === "1") {
      const checkbox = document.querySelector('#filter_v_availability'); // Escape dots in ID selector
      if (checkbox) {
        checkbox.checked = true;
      }
    }
  }
});
document.addEventListener("click", function (event) {
  const popup = document.querySelector('.smartsize_pop-up');
  if (!popup) return; // exit if popup doesn't exist

  if (event.target.closest('.opensize')) {
    // toggle popup visibility
    popup.style.display = 'block';
  }

  if (event.target.closest('.ui-dialog-titlebar-close')) {
    // toggle popup visibility
    popup.style.display = 'none';
  }
});

// SELECT A VARIANT OPTION IN PRODUCT PAGE //
// ----------------START------------------ //

// Required Variant Selection for Prestige Theme
// Handles both desktop form and mobile sticky buy bar

(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRequiredVariants);
  } else {
    initRequiredVariants();
  }

  function initRequiredVariants() {
    console.log('🚀 Initializing Required Variant Selection...');
    
    // Find all add to cart buttons EXCLUDING mobile sticky bar
    const allButtons = document.querySelectorAll('buy-buttons button[type="submit"]');
    const addToCartButtons = Array.from(allButtons).filter(button => {
      const isMobileSticky = button.closest('.mobile-sticky-product');
      if (isMobileSticky) {
        console.log('⏭️ Skipping mobile sticky button');
      }
      return !isMobileSticky;
    });
    console.log('✅ Found', addToCartButtons.length, 'Add to Cart button(s) (excluding mobile sticky)');
    
    // Find all product forms EXCLUDING mobile sticky form
    const allForms = document.querySelectorAll('product-form form');
    const productForms = Array.from(allForms).filter(form => {
      const isMobileSticky = form.closest('.mobile-sticky-product');
      if (isMobileSticky) {
        console.log('⏭️ Skipping mobile sticky form');
      }
      return !isMobileSticky;
    });
    console.log('✅ Found', productForms.length, 'product form(s) (excluding mobile sticky)');
    
    if (addToCartButtons.length === 0 || productForms.length === 0) {
      console.warn('⚠️ No buttons or forms found. Exiting.');
      return;
    }

    // Find all variant selectors EXCLUDING mobile sticky variants
    const allVariantSelectors = document.querySelectorAll(
      'variant-picker select, variant-picker input[type="radio"], .variant-picker select, .variant-picker input[type="radio"]'
    );
    const variantSelectors = Array.from(allVariantSelectors).filter(selector => {
      return !selector.closest('.mobile-sticky-product');
    });
    console.log('✅ Found', variantSelectors.length, 'variant selector(s) (excluding mobile sticky)');
    
    if (variantSelectors.length === 0) {
      // No variants, allow add to cart
      console.log('ℹ️ No variants found - product has no options. Allowing add to cart.');
      return;
    }

    // UNSELECT ALL VARIANTS BY DEFAULT (excluding mobile sticky)
    console.log('🔄 Unselecting all variants by default...');
    
    // Uncheck all radio buttons (excluding mobile sticky)
    const allRadioButtons = document.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]');
    const radioButtons = Array.from(allRadioButtons).filter(radio => !radio.closest('.mobile-sticky-product'));
    radioButtons.forEach(radio => {
      if (radio.checked) {
        console.log('  ❌ Unchecking:', radio.value);
        radio.checked = false;
      }
    });
    
    // Reset all select dropdowns to empty/first option (excluding mobile sticky)
    const allSelectDropdowns = document.querySelectorAll('variant-picker select, .variant-picker select');
    const selectDropdowns = Array.from(allSelectDropdowns).filter(select => !select.closest('.mobile-sticky-product'));
    selectDropdowns.forEach(select => {
      console.log('  🔽 Resetting dropdown:', select.name || 'unnamed');
      select.selectedIndex = 0; // Reset to first option (usually empty/placeholder)
      select.value = ''; // Clear value
    });
    
    console.log('✅ All variants unselected (mobile sticky variants left unchanged)');

    // Check if all variants are selected
    function checkVariantSelection() {
      let allSelected = true;
      let selectedCount = 0;
      let totalOptions = 0;
      let selectedVariant = null;

      // Check dropdown selects (excluding mobile sticky)
      const allSelectElements = document.querySelectorAll('variant-picker select, .variant-picker select');
      const selectElements = Array.from(allSelectElements).filter(select => !select.closest('.mobile-sticky-product'));
      selectElements.forEach(select => {
        totalOptions++;
        if (!select.value || select.value === '' || select.value === 'null') {
          allSelected = false;
          console.log('❌ Dropdown not selected:', select.name || 'unnamed');
        } else {
          selectedCount++;
          selectedVariant = select.value;
          console.log('✅ Dropdown selected:', select.name || 'unnamed', '=', select.value);
        }
      });

      // Check radio buttons (for swatch selectors, excluding mobile sticky)
      const radioGroups = {};
      const allRadios = document.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]');
      const radios = Array.from(allRadios).filter(radio => !radio.closest('.mobile-sticky-product'));
      
      radios.forEach(radio => {
        if (!radioGroups[radio.name]) {
          radioGroups[radio.name] = false;
          totalOptions++;
        }
        if (radio.checked) {
          radioGroups[radio.name] = true;
          selectedVariant = radio.value;
        }
      });

      for (let group in radioGroups) {
        if (!radioGroups[group]) {
          allSelected = false;
          console.log('❌ Radio group not selected:', group);
        } else {
          selectedCount++;
          console.log('✅ Radio group selected:', group);
        }
      }

      console.log('📊 Variant Selection Status:', selectedCount, '/', totalOptions, 'selected | All selected:', allSelected);
      return {allSelected, selectedVariant};
    }

    // Update button state for a specific button
    function updateButtonState(button) {
      let variantSelected   = checkVariantSelection();
      const allSelected     = variantSelected.allSelected;
      const selectedVariant = variantSelected.selectedVariant;
      
      // Get custom disable text from button's data attribute first, then check parent buy-buttons element
      let buttonText = button.dataset.buttonText;
      
      if (!buttonText) {
        const buyButtonsParent = button.closest('buy-buttons');
        if (buyButtonsParent) {
          buttonText = buyButtonsParent.dataset.buttonText;
          console.log('🔤 Found disable text on buy-buttons parent:', buttonText);
        }
      }
      
      // Fallback to default text
      if (!buttonText) {
        buttonText = '<font style="vertical-align: inherit;">Please Select All Options</font>';
      }
      
      console.log('🔤 Using disable text:', buttonText);
      
      if (!allSelected) {
        console.log('🔒 Disabling button:', button.textContent.trim().substring(0, 30));
        button.disabled = true;
        button.classList.add('is-disabled');
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        button.style.pointerEvents = 'none';
        
        // Store original text if not already stored
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.innerHTML;
        }
        button.innerHTML = buttonText;
      } else {
        console.log('🔓 Enabling button:', button.dataset.originalText ? 'Restored original text' : 'Button ready');
        button.disabled = false;
        button.classList.remove('is-disabled');
        button.style.opacity = '';
        button.style.cursor = '';
        button.style.pointerEvents = '';
        let optionName = document.querySelector(`input[value="${selectedVariant}"] + label`).innerText;
        // Restore original text
        // if (button.dataset.originalText) {
        //   const originalText = button.dataset.originalText || '';
        //   button.innerHTML = originalText;
        // }
      }
    }

    // Update all buttons (desktop only, excluding mobile)
    function updateAllButtons() {
      console.log('🔄 Updating all buttons (excluding mobile sticky)...');
      addToCartButtons.forEach((button, index) => {
        console.log(`  Button ${index + 1}:`, button.closest('buy-buttons') ? 'Found in buy-buttons' : 'Not in buy-buttons');
        updateButtonState(button);
      });
    }

    // Add event listeners to all variant selectors
    variantSelectors.forEach((selector, index) => {
      // selector.addEventListener('change', () => {
      //   console.log(`🎯 Variant changed (selector ${index + 1})`);
      //   updateAllButtons();
      // });
      selector.addEventListener('click', () => {
        console.log(`🖱️ Variant clicked (selector ${index + 1})`);
        updateAllButtons();
      });
    });
    console.log('✅ Event listeners attached to', variantSelectors.length, 'variant selector(s)');

    // Also listen for variant changes on the variant-picker component itself (excluding mobile sticky)
    const allVariantPickers = document.querySelectorAll('variant-picker');
    const variantPickers = Array.from(allVariantPickers).filter(picker => !picker.closest('.mobile-sticky-product'));
    
    if (variantPickers.length > 0) {
      console.log('✅ Found', variantPickers.length, 'variant-picker component(s) - adding mutation observers');
      variantPickers.forEach(picker => {
        const observer = new MutationObserver(() => {
          console.log('👁️ Variant picker mutation detected');
          updateAllButtons();
        });
        observer.observe(picker, { 
          attributes: true, 
          childList: true, 
          subtree: true 
        });
      });
    } else {
      console.log('ℹ️ No variant-picker component found');
    }

    // Initial check for all buttons
    console.log('🔍 Running initial button state check...');
    updateAllButtons();

    // Prevent form submission if not all selected (for all forms)
    productForms.forEach((form, index) => {
      console.log(`✅ Attaching submit handler to form ${index + 1}`);
      form.addEventListener('submit', function(e) {
        console.log(`📝 Form ${index + 1} submit attempted`);
        if (!checkVariantSelection()) {
          console.log('🚫 Blocking form submission - variants not selected');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Find which button was clicked
          const clickedButton = e.submitter || form.querySelector('button[type="submit"]');
          
          if (clickedButton) {
            console.log('💥 Shaking button');
            // Add shake animation to the clicked button
            clickedButton.style.animation = 'shake 0.5s';
            setTimeout(() => {
              clickedButton.style.animation = '';
            }, 500);
          }
          
          // Scroll to variant selector (only if not already visible)
          const variantSection = document.querySelector('variant-picker, .variant-picker');
          if (variantSection) {
            const rect = variantSection.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
            
            console.log('👁️ Variant picker visible:', isVisible);
            
            if (!isVisible) {
              console.log('⬆️ Scrolling to variant picker');
              variantSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            
            // Highlight the variant picker briefly
            console.log('✨ Highlighting variant picker');
            variantSection.style.transition = 'all 0.3s';
            variantSection.style.outline = '2px solid #ff6b6b';
            variantSection.style.outlineOffset = '4px';
            setTimeout(() => {
              variantSection.style.outline = '';
            }, 2000);
          }
          
          return false;
        } else {
          console.log('✅ Form submission allowed - all variants selected');
        }
      }, true); // Use capture phase to catch event early
    });

    // Also add click listeners directly to buttons as backup
    addToCartButtons.forEach((button, index) => {
      console.log(`✅ Attaching click handler to button ${index + 1}`);
      button.addEventListener('click', function(e) {
        console.log(`🖱️ Button ${index + 1} clicked`);
        if (!checkVariantSelection()) {
          console.log('🚫 Blocking button click - variants not selected');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Add shake animation
          console.log('💥 Shaking button');
          button.style.animation = 'shake 0.5s';
          setTimeout(() => {
            button.style.animation = '';
          }, 500);
          
          // Scroll to variant selector
          const variantSection = document.querySelector('variant-picker, .variant-picker');
          if (variantSection) {
            const rect = variantSection.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
            
            console.log('👁️ Variant picker visible:', isVisible);
            
            if (!isVisible) {
              console.log('⬆️ Scrolling to variant picker');
              variantSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            
            // Highlight the variant picker
            console.log('✨ Highlighting variant picker');
            variantSection.style.transition = 'all 0.3s';
            variantSection.style.outline = '2px solid #ff6b6b';
            variantSection.style.outlineOffset = '4px';
            setTimeout(() => {
              variantSection.style.outline = '';
            }, 2000);
          }
          
          return false;
        } else {
          console.log('✅ Button click allowed - all variants selected');
        }
      }, true);
    });
    
    console.log('✅ Required Variant Selection initialized successfully!');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  }
})();

// Add shake animation CSS
const style = document.createElement('style');
style.textContent = `
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-8px); }
    20%, 40%, 60%, 80% { transform: translateX(8px); }
  }
  
  buy-buttons button.is-disabled {
    pointer-events: none !important;
  }
`;
document.head.appendChild(style);
// SELECT A VARIANT OPTION IN PRODUCT PAGE //
// ----------------END-------------------- //

// STICKY ADD TO CART BUTTON ON PRODUCT PAGE //
// ----------------START-------------------- //
document.addEventListener('DOMContentLoaded', () => {
  const cartBlock = document.querySelector('[data-block-id="buy_buttons"] buy-buttons');
  const buyButtonsContainer = document.querySelector('[data-block-id="buy_buttons"]');
  
  if (!cartBlock || !buyButtonsContainer) return;
  
  const variantPicker = document.querySelector('[data-block-type="vendor"]');
  let isSticky = false;
  let lastScrollY = window.scrollY;
  let isScrollingUp = false;
  
  // Initialize: Fixed at bottom with mb-buy-buttons class
  // cartBlock.classList.add('mb-buy-buttons');
  
  // Track scroll direction
  window.addEventListener('scroll', () => {
    isScrollingUp = window.scrollY < lastScrollY;
    lastScrollY = window.scrollY;
  }, { passive: true });
  
  // Setup Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Container is in view, make button sticky
        if (!isSticky) {
          isSticky = true;
          cartBlock.classList.add('position-sticky');
        }
      } else {
        // Container is NOT in view
        // Only revert to fixed if we're scrolling UPWARDS (back to top)
        if (isSticky && isScrollingUp) {
          isSticky = false;
          cartBlock.classList.remove('position-sticky');
        }
        // If scrolling DOWN and container is out of view (at bottom), keep it sticky
        // Do nothing - keep the sticky class
      }
    });
  }, {
    threshold: 0.1
  });
  
  // Start observing
  observer.observe(buyButtonsContainer);
  
  // Click handler
  if (variantPicker) {
    cartBlock.addEventListener('click', (e) => {
      e.preventDefault();
      variantPicker.classList.add('scroll-margin-top');
      variantPicker.scrollIntoView({ behavior: 'smooth'});
    });
  }
});

// STICKY ADD TO CART BUTTON ON PRODUCT PAGE //
// ----------------END---------------------- //

// HIDE COLLECTION DESC, FAQ's UNLESS IT IS PAGE 1 //
// ---------------------START--------------------- //
(function () {
  const SELECTORS = {
    desc: ".hh-collection-desc",
    faq: ".collection-faqs",
    heading: ".hh-collection-heading",
    title: "title"
  };

  let cache = { elements: null, page: null };
  let originalTexts = { heading: null, title: null };

  function getLocale() {
    const path = window.location.pathname;
    if (path.includes('/de-de/') || path.startsWith('/de-de')) {
      return 'de';
    }
    return 'en';
  }

  function getPageText() {
    return getLocale() === 'de' ? 'Seite' : 'Page';
  }

  function getPageParam() {
    const params = new URLSearchParams(window.location.search);
    return params.get("page") || "1";
  }

  function stripPageNumber(text) {
    // Remove " – Page X", " – Seite X", or " – X" from the end
    return text.replace(/\s*–\s*(Page|Seite)?\s*\d+\s*$/, '').trim();
  }

  function getElements() {
    if (!cache.elements) {
      const heading = document.querySelector(SELECTORS.heading);
      const title = document.querySelector(SELECTORS.title);
      
      cache.elements = {
        desc: document.querySelector(SELECTORS.desc),
        faq: document.querySelector(SELECTORS.faq),
        heading: heading,
        title: title
      };

      if (heading && !originalTexts.heading) {
        originalTexts.heading = stripPageNumber(heading.textContent.trim());
      }
      if (title && !originalTexts.title) {
        originalTexts.title = stripPageNumber(title.textContent.trim());
      }
    }
    return cache.elements;
  }

  function toggleElements() {
    const page = getPageParam();
    
    if (page === cache.page) return;
    cache.page = page;

    const { desc, faq, heading, title } = getElements();
    const isFirst = page === "1";
    const display = isFirst ? "" : "none";

    if (desc) desc.style.display = display;
    if (faq) faq.style.display = display;

    const pageText = getPageText();

    if (heading && originalTexts.heading) {
      heading.textContent = isFirst
        ? originalTexts.heading
        : `${originalTexts.heading} – ${pageText} ${page}`;
    }

    if (title && originalTexts.title) {
      title.textContent = isFirst
        ? originalTexts.title
        : `${originalTexts.title} – ${page}`;
    }
  }

  toggleElements();

  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      cache.elements = null;
      toggleElements();
    }, 150);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  const patchHistory = (method) => {
    const orig = history[method];
    history[method] = function () {
      orig.apply(this, arguments);
      toggleElements();
    };
  };

  patchHistory("pushState");
  patchHistory("replaceState");
  window.addEventListener("popstate", toggleElements);
})();

// HIDE COLLECTION DESC, FAQ's UNLESS IT IS PAGE 1 //
// ---------------------END--------------------- //

// SCROLL TO TOP BUTTON ON COLLECTION //
// -------------START---------------- //

if (!window.location.pathname.includes('/products/')) {

  let scrollListener = null;

  function getScrollBtn() {
    return document.getElementById("scrollToTopBtn");
  }

  function updateScrollBtnVisibility() {
    const scrollBtn = getScrollBtn();
    if (!scrollBtn) return;

    const show = window.pageYOffset > 200;

    if (show) {
      scrollBtn.classList.add("show");
    } else {
      scrollBtn.classList.remove("show");
    }
  }

  function initScrollToTopBtn() {
    const scrollBtn = getScrollBtn();
    if (!scrollBtn) return;

    // avoid duplicate binding
    if (scrollBtn.dataset.bound === "true") return;
    scrollBtn.dataset.bound = "true";

    if (scrollListener) {
      window.removeEventListener("scroll", scrollListener);
    }

    scrollListener = updateScrollBtnVisibility;
    window.addEventListener("scroll", scrollListener, { passive: true });

    updateScrollBtnVisibility();

    scrollBtn.addEventListener("click", (e) => {
      e.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }

  const domObserver = new MutationObserver(() => {
    if (document.getElementById("scrollToTopBtn")) {
      initScrollToTopBtn();
    }
  });

  domObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("fdt:pagination:updated", () => {
    setTimeout(initScrollToTopBtn, 300);
  });
}

// PAGINATION CLICK HANDLER
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-page]");
  if (!btn) return;
  if (btn.classList.contains("disabled")) return;
  if (btn.getAttribute("aria-disabled") === "true") return;

  window.scrollTo({ top: 0, behavior: "smooth" });

  setTimeout(() => {
    document.dispatchEvent(new CustomEvent("fdt:pagination:updated"));
  }, 800);
});

const STORAGE_KEY = "mobile_grid_layout";

function applyMobileGridLayout(value) {
    const resultsContainer = document.querySelector("fdt-search-product-results");
    if (!resultsContainer) return;

    if (value === "large") {
        resultsContainer.classList.add("search-filters__product-list-mobile-grid-1-col");
        resultsContainer.classList.remove("search-filters__product-list-mobile-grid-2-col");
    } else {
        resultsContainer.classList.add("search-filters__product-list-mobile-grid-2-col");
        resultsContainer.classList.remove("search-filters__product-list-mobile-grid-1-col");
    }
}

function getSavedLayout() {
    return localStorage.getItem(STORAGE_KEY);
}

function setSavedLayout(value) {
    localStorage.setItem(STORAGE_KEY, value);
}

function getActiveLayoutValue() {
    const activeBtn = document.querySelector(
        "collection-layout-switch[device='mobile'] .collection-toolbar__button.is-active"
    );

    return activeBtn ? activeBtn.value : "medium"; // default fallback
}

// Apply on page load
document.addEventListener("DOMContentLoaded", () => {
    const savedLayout = getSavedLayout();
    const initialLayout = savedLayout || getActiveLayoutValue();

    applyMobileGridLayout(initialLayout);

    // also sync UI state with saved value
    if (savedLayout) {
        const buttons = document.querySelectorAll(
            "collection-layout-switch[device='mobile'] .collection-toolbar__button"
        );

        buttons.forEach(btn => {
            btn.classList.toggle("is-active", btn.value === savedLayout);
        });
    }
});

// Apply on click
document.addEventListener("click", (e) => {
    const btn = e.target.closest(
        "collection-layout-switch[device='mobile'] .collection-toolbar__button"
    );
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const layoutSwitch = btn.closest("collection-layout-switch");

    // toggle off -> reset to default
    if (btn.classList.contains("is-active")) {
        btn.classList.remove("is-active");
        localStorage.removeItem(STORAGE_KEY);
        applyMobileGridLayout("medium");
        return;
    }

    // update active UI
    layoutSwitch.querySelectorAll(".collection-toolbar__button")
        .forEach(b => b.classList.remove("is-active"));

    btn.classList.add("is-active");

    // save + apply
    setSavedLayout(btn.value);
    applyMobileGridLayout(btn.value);
});

window.addEventListener('load', () => {
  const agent = document.querySelector('shopify-agent');
  if (!agent) return;

  const drawer = document.querySelector('.drawer'); // Change if needed
  const searchDisclosure = document.querySelector('.search-filters__disclosure');
  const wishlistDrawer = document.querySelector('.wishlist-drawer-show');

  const toggleChat = () => {
    const drawerOpen = drawer?.hasAttribute('open');
    const searchOpen = searchDisclosure?.hasAttribute('open');
    const wishlistOpen = wishlistDrawer?.classList.contains('show');

    agent.style.display = (drawerOpen || searchOpen || wishlistOpen) ? 'none' : '';
  };

  // Initial check
  toggleChat();

  if (drawer) {
    new MutationObserver(toggleChat).observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  if (searchDisclosure) {
    new MutationObserver(toggleChat).observe(searchDisclosure, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  if (wishlistDrawer) {
    new MutationObserver(toggleChat).observe(wishlistDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});